import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      events: [
        {
          title: 'event1',
          start: '2021-09-07'
        },
        
        {
          title: 'event2',
          start: '2021-09-17T12:30:00',
          allDay: false
        },
        {
          title: 'event3',
          start: '2021-09-21',
          end: '2021-09-24'
        }
      ],
      config: {
        defaultView: 'month'
      }
    }
  },
  components: {
    FullCalendar,
    DashboardHeader,
    SideNav
  },
  mounted () {
    // window.analytics.page('CalendarPage')
    window.analytics.identify('CalendarPage', {
      path: '/CalendarPage'
    })
  },
  methods: {
  }
}
